export const eq1 = {
  name: `eq1`,
  sql: `
    SELECT * FROM solano_eq1
    WHERE haz_eq1 IN ('Severe', 'Very Strong', 'Strong', 'Moderate')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_eq1], (#7efbdf, #95f879,  #f7f835, #fdca2c, #ff701f, #ec2516), ("Light", "Moderate", "Strong", "Very Strong", "Severe", "Violent"), =);
      polygon-opacity: 0.5;
      polygon-comp-op: screen;
    }
    #layer::outline {
      line-width: 0;
      line-color: #FFFFFF;
      line-opacity: 0.5;
    }
  `,
  // viz: `
  //   strokeWidth: 0
  //   color: ramp(buckets($haz_eq1, ["Severe", "Very Strong", "Strong", "Moderate", "Light"]), [opacity(#FF701F, 0.5),opacity(#FDCA2C, 0.5), opacity(#F7F835, 0.5), opacity(#95F879, 0.5), opacity(#7EFBDF, 0.5)])
  //   `
}